<header id="header"
    class="navbar navbar-expand-lg navbar-bordered navbar-spacer-y-0 flex-lg-column">

    <!-- TOP HEADER -->
    <div class="navbar-light shadow w-100 bg-gradient bg-light py-2">
        <div class="container">

            <nav class="js-mega-menu navbar-nav-wrap hs-menu-initialized hs-menu-horizontal">

                <!-- LOGO -->
                <a class="navbar-brand me-5 me-md-0"
                    routerLink="/{{mainPath}}/Dashboard"
                    aria-label="Front"
                    *ngIf="isProduction">

                    <img class="navbar-brand-logo"
                        [src]="upFooterLogoPicSrc"
                        alt="Logo"
                        data-hs-theme-appearance="default">

                </a>

                <!-- RIGHT SIDE -->
                <div class="navbar-nav-wrap-secondary-content">

                    <!-- MOBILE TOGGLER -->
                    <button class="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarDoubleLineContainerNavDropdown"
                        aria-controls="navbarDoubleLineContainerNavDropdown"
                        aria-expanded="false"
                        aria-label="Toggle navigation">

                        <span class="navbar-toggler-default">
                            <i class="bi-list"></i>
                        </span>

                        <span class="navbar-toggler-toggled">
                            <i class="bi-x"></i>
                        </span>

                    </button>

                    <!-- LANGUAGE -->
                    <a class="btn btn-default navbar-btn"
                        role="button"
                        (click)="changeLanguage()">

                        {{'lang'|translate}}

                    </a>

                    <!-- TEST -->
                    <a class="btn btn-default navbar-btn text-primary">
                        إطلاق تجريبي
                    </a>

                    <!-- PHONE -->
                    <a class="btn btn-default navbar-btn" href="#">
                        065608400
                    </a>

                </div>

                <div class="collapse navbar-collapse"
                    id="navbarContainerNavDropdown">

                    <ul class="navbar-nav"></ul>

                </div>

            </nav>

        </div>
    </div>

    <!-- BOTTOM NAVBAR -->
   <div class="container-fluid bg-blue px-0">

    <nav class="w-100">

        <div class="collapse navbar-collapse show w-100"
            id="navbarDoubleLineContainerNavDropdown">

            <ul class="navbar-nav w-100 d-flex flex-row align-items-center m-0 px-0">

                <li class="nav-item">
                    <a class="hs-mega-menu-invoker nav-link"
                        routerLink="/{{mainPath}}/Dashboard">

                        <i class="bi-house dropdown-item-icon text-white-50"></i>
                        {{'home'|translate}}

                    </a>
                </li>

                <li class="nav-item">
                    <a class="hs-mega-menu-invoker nav-link"
                        routerLink="/{{mainPath}}/Profile">

                        <i class="bi-person dropdown-item-icon text-white-50"></i>
                        {{'profile'|translate}}

                    </a>
                </li>

                <li class="nav-item">
                    <a class="hs-mega-menu-invoker nav-link"
                        routerLink="/Sections"
                        [queryParams]="{SectionId: SectionId}">

                        <i class="bi-files-alt dropdown-item-icon text-white-50"></i>
                        {{'e-service'|translate}}

                    </a>
                </li>

                <li class="nav-item">
                    <a class="hs-mega-menu-invoker nav-link"
                        routerLink="/MyRequests">

                        <i class="bi-window-stack dropdown-item-icon text-white-50"></i>
                        {{'requests'|translate}}

                    </a>
                </li>

                <!-- PUSH TO END -->
                <li class="nav-item logout-item">
    <button (click)="logout()"
        class="hs-mega-menu-invoker nav-link bg-transparent border-0">

        <i class="bi-box-arrow-left dropdown-item-icon text-white-50"></i>
        {{'logout'|translate}}

    </button>
</li>

            </ul>

        </div>

    </nav>

</div>

</header>

<!-- ACCESSIBILITY -->
<!--
<a id="lnkAccessibility" class="access-icon">
    Accessibility Menu
</a>
-->

<router-outlet></router-outlet>

<!-- FOOTER -->
<footer class="container-fluid text-center bg-blue navbar-dark pt-5 pb-10"
    *ngIf="isProduction">

    <div class="row justify-content-center">

        <div class="col-auto">

            <img [src]="downFooterLogoPicSrc"
                style="max-width: 180px;"
                class="img-fluid mb-2">

            <p class="text-white-50 text-end">
                {{'footer1'|translate}}
            </p>

        </div>

    </div>

    <p class="mb-0 text-white-50">
        &#64; {{getYear()}}
        {{'footer2'|translate}}
        {{'footer3'|translate}}
    </p>

</footer>